var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-xl bg-blue-700 text-white px-4 py-2 focus:outline-none hover:bg-blue-600",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }